export const EmploymentDetailsState = {
  current_employment: {
    employee_id: "",
    email: "",
    employment_type: "",
    designation: "",
    joined_at: "",
    resigned_at: "",
  },
  previous_employments: [
    {
      company_name: "",
      role: "",
      id: "",
    },
  ],
};
